module.exports = {"id":"216594","name":"Nabil Fekir","rating":"84","photo":"./data/images/photos/4/216594.png","club":{"name":"OL","logo":"./data/images/clubs/OL.png"},"positions":["MOC","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NabilFekir0.json
// module id = 3114
// module chunks = 0